import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DynamicFormModal, { ENTITY_CONFIGS } from '../../../formBuilder/wrappers/DynamicFormModal';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteInstrument } from '../../../../services/clinicPortalServices/instrumentService';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

const panelStyles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 },
    panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' },
    header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' },
    title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' },
    body: { padding: '20px', flex: 1 },
    section: { marginBottom: '20px' },
    sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' },
    dl: { display: 'grid', gridTemplateColumns: '140px 1fr', rowGap: '8px', margin: 0 },
    dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' },
    dd: { fontSize: '13px', color: '#222', margin: 0 },
    editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' },
    closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' }
};

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            instrumentId: props.data._id
        };
    }

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this instrument!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container: window.localStorage.getItem('appTheme') === 'Dark' && /clinic|lims/.test(window.location.pathname.split('/')[1]) && 'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteInstrument({ _id: this.state.instrumentId, name: this.props.data.name }).then(() => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
        const instrument = this.props.data;
        if (instrument) {
            trackRecentView('instrument', instrument._id, instrument.name || 'Instrument', '/clinic/instrument');
        }
    };

    handleClose = () => this.setState({ show: false });

    renderPanel() {
        const d = this.props.data;
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>Instrument Details</h5>
                        <div>
                            <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}>
                                <i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit
                            </button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Instrument Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Name</dt>
                                <dd style={panelStyles.dd}>{d.name || '—'}</dd>
                                <dt style={panelStyles.dt}>Type</dt>
                                <dd style={panelStyles.dd}>{d.type || '—'}</dd>
                                <dt style={panelStyles.dt}>Serial Number</dt>
                                <dd style={panelStyles.dd}>{d.serialNumber || '—'}</dd>
                                <dt style={panelStyles.dt}>UID</dt>
                                <dd style={panelStyles.dd}>{d.uid || '—'}</dd>
                                <dt style={panelStyles.dt}>SSH Tunnel</dt>
                                <dd style={panelStyles.dd}>{d.sshTunnel || '—'}</dd>
                                <dt style={panelStyles.dt}>Last Seen</dt>
                                <dd style={panelStyles.dd}>{d.lastSeen || '—'}</dd>
                                <dt style={panelStyles.dt}>Created By</dt>
                                <dd style={panelStyles.dd}>{d.createdBy || '—'}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </>,
            document.body
        );
    }

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Instrument</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Edit Instrument</Tooltip>}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Delete Instrument</Tooltip>}>
                    <button onClick={this.handleDelete} className="edit-order-btn">
                        <i className="fas fa-trash"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <ModalStyled size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={this.state.show} onHide={this.handleClose} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Update Instrument Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DynamicFormModal entityType="instrument" entityId={this.state.instrumentId} entityConfig={ENTITY_CONFIGS.instrument} context={this.props.context} handleClose={this.handleClose} />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
